<style>

.tableDesign .el-input__inner{
  border: 0;
  text-align: center;
}
</style>
<template>
  <BasicLayout>
    <template #wrapper>
      <el-tabs active-name="base" tab-position="left" style="background-color: #ffffff;height: 800px" @tab-click="handleTabClick">
        <el-tab-pane label="基础配置" name="base">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <el-row :gutter="10" class="mb8">
                <clear-cache-apply />
              </el-row>
            </div>
            <el-form class="demo-form-inline" :inline="true">
              <el-form-item label="显示人数">
                <el-input v-model.number="list.showLen" size="mini" style="width: 200px" placeholder="显示人数" />
              </el-form-item>
              <el-button v-prevent-re-click style="margin-top: 5px;" size="mini" type="primary" @click="handleSaveBase()">保存</el-button>
            </el-form>
          </el-card>
        </el-tab-pane>
        <el-tab-pane v-for="(item,type) in typeArr" :key="type" :name="type" :label="item">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <el-row :gutter="10" class="mb8">
                <CommonExcel ref="CommonExcelRef2" :import-p="'config:userLabel:import'" :export-p="'config:userLabel:export'" :import-method="importCfg" :export-method="exportCfg" />
                <clear-cache-apply />
              </el-row>
            </div>
            <el-table class="tableDesign" size="mini" :data="list[type]" border style="width: 50%">
              <template v-if="type === 'robot'">
                <el-table-column label="类型" align="center">
                  <template slot-scope="{row}">
                    <el-select v-model="row.type" placeholder="请选择">
                      <el-option
                        v-for="item in rankType"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      />
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column label="范围" align="center">
                  <template slot-scope="{row}">
                    <el-input v-model.number="row.min" style="width: 45%" placeholder="最小值" />
                    <span style="padding: 0 7px;" />
                    <el-input v-model.number="row.max" style="width: 45%" placeholder="最大值" />
                  </template>
                </el-table-column>
              </template>
              <template v-else>
                <el-table-column label="排名" align="center">
                  <template slot-scope="{row}">
                    <el-input v-model.number="row.rank" placeholder="排名" />
                  </template>
                </el-table-column>
                <el-table-column label="奖励" align="center">
                  <template slot-scope="{row}">
                    <Reward v-model="row.reward" />
                  </template>
                </el-table-column>
              </template>
              <el-table-column label="操作" align="center">
                <template slot-scope="{row,$index}">
                  <el-button type="danger" size="mini" @click="handleDel(type,$index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div style="float:left;margin-top: 1rem">
              <el-button type="primary" size="mini" @click="handleAdd(type)">新增</el-button>
              <el-button v-prevent-re-click type="primary" size="mini" style="margin:10px 10px" @click="handleSaveBase(type)">保存</el-button>
            </div>
          </el-card>
        </el-tab-pane>
      </el-tabs>
    </template>
  </BasicLayout>
</template>

<script>

import CommonExcel from '@/components/CommonExcel'
import Reward from '@/components/Reward'
import { downloadExcelMultiSheet } from '@/utils/excel'
import ClearCacheApply from '@/components/clear_cache_apply/index.vue'
import { getCommonCfg, updateCommonCfg } from '@/api/config/common-cfg'
import SyncData from '@/components/syncData/index.vue'

export default {
  name: 'LikeRank',
  components: { SyncData, ClearCacheApply, CommonExcel, Reward },
  data() {
    return {
      curClass: 'likeRank',
      loading: false,
      dialog: false,
      diaLogList: [],
      list: { showLen: 50, beast: [], shield: [], dice: [], robot: [] },
      type: 'beast',
      rankType: [{ label: '野兽', value: 1 }, { label: '骰子', value: 2 }, { label: '盾牌', value: 3 }],
      typeArr: { beast: '野兽配置', shield: '盾牌配置', dice: '骰子配置', robot: '机器人配置' },
      baseList: [],
      mapDialog: false,
      mapDialogList: [],
      groupsList: []
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.getList()
    },
    handleSaveBase() {
      if (this.list.showLen <= 0) {
        this.msgError('显示人数不能是0')
        return
      }
      updateCommonCfg({ name: this.curClass, data: JSON.stringify(this.list) }).then(res => {
        this.msgSuccess('保存成功')
      })
    },
    handleTabClick(val) {
      this.type = val.name
    },
    importBaseCfg(excelInfo) {
      const excelData = excelInfo.data
      for (let i = 0; i < excelData.length; i++) {
        const list = this.$refs.CommonExcelRef.tranToTarget(excelData[i].sheetData, { groupIds: this.groupsList, revive: this.list[3] }, true, 'name', 'id')
        for (let i = 0; i < list.length; i++) {
          list[i].mapWeight = this.$refs.CommonExcelRef.tranToTarget(list[i].mapWeight, { id: this.list[2] }, true, 'name', 'id')
        }
        this.baseList = list
        this.handleSaveBase()
        break
      }
    },
    exportBaseCfg() {
      const fileName = '点赞排行榜配置'
      const hearer = []
      const excelData = []
      const name = ['点赞排行榜配置']
      const list = this.$refs.CommonExcelRef.tranToTarget(this.baseList, { groupIds: this.groupsList, revive: this.list[3] }, true, 'id', 'name')
      for (let i = 0; i < list.length; i++) {
        list[i].mapWeight = this.$refs.CommonExcelRef.tranToTarget(list[i].mapWeight, { id: this.list[2] }, true, 'id', 'name')
      }
      const tAk = this.$refs.CommonExcelRef.makeExcelData(list, { minLv: '最小等级', maxLv: '最大等级', groupIds: { name: '用户分组', sub: [] }, revive: '复活配置', mapWeight: { name: '地图配置', sub: { v: '权重', id: '地图', background: '背景' }}})
      hearer.push(tAk[0])
      excelData.push(tAk[1])
      downloadExcelMultiSheet(this.$route.meta.title + fileName, name, hearer, excelData)
    },
    getList() {
      this.loading = true
      getCommonCfg({ name: this.curClass }).then(res => {
        if (res.data) {
          this.list = res.data
        }
      })
    },
    handleDel(type, index) {
      this.list[type].splice(index, 1)
    },
    handleAdd(type) {
      if (!this.list[type]) {
        this.$set(this.list, type, [])
      }
      if (type === 'robot') {
        this.list[type].push({ type: 1, min: 1, max: 1 })
      } else {
        this.list[type].push({ rank: 1, reward: [] })
      }
    },
    importCfg(updateInfo) {
      const excelData = updateInfo.data
      for (let i = 0; i < excelData.length; i++) {
        this.list[this.type] = excelData[i].sheetData
      }
    },
    exportCfg() {
      const nameArr = [this.typeArr[this.type]]
      const dataArr = [this.list[this.type]]
      this.onExport(this.type, nameArr, dataArr)
      return Promise.reject()
    },
    onExport(type, name, dataArr) {
      let fileName = ''
      const hearer = []
      const excelData = []
      fileName = this.typeArr[type]
      let tranTitle = {}
      if (type === 'robot') {
        tranTitle = { type: '类型', min: '最小值', max: '最大值' }
      } else {
        tranTitle = {
          rank: '排名',
          reward: { name: '奖励', sub: { propsId: '道具', num: '数量', rtype: '取值类型', skin: '皮肤' }}
        }
      }

      for (let i = 0; i < dataArr.length; i++) {
        const tAk = this.$refs.CommonExcelRef2[0].makeExcelData(dataArr[i], tranTitle)
        hearer.push(tAk[0])
        excelData.push(tAk[1])
      }
      downloadExcelMultiSheet(this.$route.meta.title + fileName, name, hearer, excelData)
    }
  }
}
</script>

